import { all, takeEvery, call, put } from 'redux-saga/effects';
import ApiInstance from 'src/helpers/apiInstance';
import actions from './actions';
import { sendRequest } from '../../../../../helpers/saga';
import notifications from '../../../../../redux/notifications/actions';
import { logger } from '../../../../../helpers/logger';
import { tableConfig } from '../../../../../settings';

const loadAgenciesApi = new ApiInstance('units/:id/agencies');

function* loadAgencies({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '', id } = payload;

    const result = yield call(
      sendRequest,
      loadAgenciesApi.get,
      { search: { page, pageSize, column, order, filter }, pathParams: { id } },
      notifications.REQUEST_ERROR,
    );

    if (result?.status === 200) {
      const { records } = result.data;

      yield put(
        actions.loadAgenciesSuccess({
          agencies: records,
        }),
      );
    } else {
      yield put(actions.loadAgenciesError());
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_AGENCIES_REQUEST, loadAgencies)]);
}
